import React from 'react';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import { persistStore, persistReducer } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import storage from 'redux-persist/lib/storage';
import { ThemeProvider } from 'styled-components';
import { createBrowserHistory } from 'history';
import { Grommet } from 'grommet';
import { Web3ReactProvider } from '@web3-react/core';
import { pulsechainTheme } from './styles/pulsechainTheme';
import { styledComponentsTheme } from './styles/styledComponentsTheme';
import { Routes as RoutedContent } from './Routes';
import { GlobalStyles } from './styles/GlobalStyles';
import { reducers } from './store/reducers';
import { LocalizedRouter } from './pulsechain_components/LocalizedRouter';
import { Footer } from './pulsechain_components/Footer';
import { connectors } from './connectors';
import { InjectedWalletProvider } from './connectors/InjectedWalletContext';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['workflow', 'acknowledgementState', 'client', 'depositFile'], // persist workflow, deposit data, and transaction status
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = createStore(
  persistedReducer,
  // @ts-ignore
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

export const persistor = persistStore(store);

export const history = createBrowserHistory();

export const App: React.FC = () => {
  return (
    <Web3ReactProvider connectors={connectors as any}>
      <InjectedWalletProvider>
        <LocalizedRouter history={history}>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <Grommet theme={pulsechainTheme}>
                <ThemeProvider theme={styledComponentsTheme}>
                  <GlobalStyles />
                  <RoutedContent />
                  <Footer />
                </ThemeProvider>
              </Grommet>
            </PersistGate>
          </Provider>
        </LocalizedRouter>
      </InjectedWalletProvider>
    </Web3ReactProvider>
  );
};
